'use client';

import Link from 'next/link';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Navigation from '../../components/Navigation';
import RelatedPages from '../../components/RelatedPages';
import { GuideEyebrow, GuideSubtitle, GuideTitle } from '../../components/GuideHeading';

const guides = [
    {
        title: 'JSON Patch in Python',
        description: 'Apply and generate RFC 6902 patches with the jsonpatch library: apply_patch, make_patch, error handling and the test operation.',
        href: '/guides/json-patch-in-python',
    },
    {
        title: 'JSON Patch in JavaScript',
        description: 'Use fast-json-patch in Node and the browser: applyPatch, compare, immutable updates and common pitfalls.',
        href: '/guides/json-patch-in-javascript',
    },
    {
        title: 'JSON Patch in Go',
        description: 'Apply and generate RFC 6902 patches with evanphx/json-patch: DecodePatch, Apply, CreatePatch and test-failure handling.',
        href: '/guides/json-patch-in-go',
    },
    {
        title: 'JSON Patch in Java',
        description: 'Apply and generate RFC 6902 patches with Jackson and java-json-tools: JsonPatch.apply, JsonDiff.asJsonPatch and pitfalls.',
        href: '/guides/json-patch-in-java',
    },
    {
        title: 'JSON Patch vs JSON Merge Patch',
        description: 'RFC 6902 vs RFC 7396: array handling, failure semantics, the null trap, and which format your API should accept.',
        href: '/guides/json-patch-vs-json-merge-patch',
    },
];

export default function GuidesIndex() {
    return (
        <>
            <Navigation activePage="docs" />
            <main>
                <Container maxWidth="lg" className="main-container">
                    <GuideEyebrow sx={{ textAlign: "center" }}>Learn</GuideEyebrow>
                    <GuideTitle sx={{ textAlign: "center" }}>JSON Patch Guides</GuideTitle>
                    <GuideSubtitle sx={{ mx: "auto", textAlign: "center" }}>
                        Practical, code-first tutorials for working with RFC 6902 JSON Patch in real projects.
                    </GuideSubtitle>

                    <Grid container spacing={3} sx={{ mt: 4 }}>
                        {guides.map((g) => (
                            <Grid item xs={12} md={4} key={g.href}>
                                <Link href={g.href} style={{ textDecoration: 'none' }}>
                                    <Paper
                                        elevation={0}
                                        sx={{
                                            p: 3,
                                            height: '100%',
                                            border: '1px solid var(--border)',
                                            borderRadius: 'var(--radius-lg)',
                                            transition: 'border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease',
                                            '&:hover': {
                                                borderColor: 'var(--accent)',
                                                transform: 'translateY(-2px)',
                                                boxShadow: '0 8px 24px rgba(15, 23, 42, 0.08)',
                                            },
                                        }}
                                    >
                                        <Typography variant="h3" gutterBottom sx={{ color: 'var(--fg)', fontSize: '1.2rem', fontWeight: 600, letterSpacing: '-0.01em' }}>
                                            {g.title}
                                        </Typography>
                                        <Typography sx={{ color: 'var(--fg-muted)' }}>
                                            {g.description}
                                        </Typography>
                                    </Paper>
                                </Link>
                            </Grid>
                        ))}
                    </Grid>

                    <RelatedPages currentPage="docs" />
                </Container>
            </main>
        </>
    );
                                            }
